import React, { useContext, useEffect, useState } from 'react';
import classes from './reportBugModal.module.scss'

interface IProps {
  className?: string
  handle?: any
}
enum EPingType {
  good = 'good',
  medium = 'medium',
  bad = 'bad',
  notPlayable = 'notPlayable'
}
function GameTopLayer({ handle }: IProps) {
  const handleReport = () => {
    window.open("https://forms.gle/2sdLyLNQxL9gXATs9", '_blank', 'noopener,noreferrer')
  }
  return (
    <div className={ classes.modal }>
      <div className={classes.title}>
        Experiencing any issues?
      </div>
      <div className={classes.description}>
        Have you encountered any bugs? Tell us about them and we will get them fixed in no time!
      </div>
      <div  className={classes.btn} onClick={handleReport}>
        Tell us about the bug
      </div>
  </div>
  );
}

export default GameTopLayer;
